import React, { ButtonHTMLAttributes } from 'react'

import * as S from './styles'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: string
  loading?: boolean
}

const Button = ({ children, ...rest }: ButtonProps) => (
  <S.Container type="button" {...rest}>
    {children}
  </S.Container>
)

export default Button

export const ButtonPrimary = ({ children, loading, ...props }: ButtonProps) => {
  return (
    <S.ContainerButton>
      <button {...props}>
        {loading ? <div className="loading"></div> : children}
      </button>
    </S.ContainerButton>
  )
}
